module.exports = __webpack_public_path__ + "img/device-bg.1b3ce422.png";